import { Link } from 'react-router-dom';

import { Boxes, LockKeyhole, LogOut } from '../../lib/icons';
import { IdleLockOverlay } from '../auth/IdleLockOverlay';
import { useAuth } from '../auth/AuthContext';
import {
  OPERATIONAL_UNIT_LABELS,
  OPERATIONAL_UNIT_PATHS,
  type OperationalUnitCode,
} from './types';

const UNIT_DESCRIPTIONS: Record<OperationalUnitCode, string> = {
  SKOFJA_LOKA:
    'Obstoječi WMS: izdelki, mape, naročila, dashboard in nastavitve.',
  LOGATEC: 'Ločen modul za funkcije in procese enote Logatec.',
};

export function UnitSelectionPage() {
  const { user, lock, signOut } = useAuth();

  return (
    <div className="unit-portal">
      <header className="unit-portal__header">
        <div className="unit-portal__identity">
          <img src="/Logo_WMS.png" alt="" width="40" height="41" />
          <div>
            <strong>{user?.displayName}</strong>
            <span>Izberite enoto</span>
          </div>
        </div>
        <div className="unit-portal__actions">
          <button className="header-button" type="button" onClick={lock}>
            <LockKeyhole size={18} />
            <span>Zakleni</span>
          </button>
          <button
            className="header-button"
            type="button"
            onClick={() => void signOut()}
          >
            <LogOut size={18} />
            <span>Odjava</span>
          </button>
        </div>
      </header>
      <main className="unit-portal__content">
        <div className="unit-portal__heading">
          <p className="eyebrow">WMS</p>
          <h1>Izberite enoto</h1>
          <p>Prikazane so samo enote, do katerih imate dovoljen dostop.</p>
        </div>
        <div className="unit-grid">
          {user?.unitCodes.map((unitCode) => (
            <Link
              className="unit-card"
              key={unitCode}
              to={OPERATIONAL_UNIT_PATHS[unitCode]}
            >
              <Boxes size={28} aria-hidden="true" />
              <span>
                <strong>{OPERATIONAL_UNIT_LABELS[unitCode]}</strong>
                <small>{UNIT_DESCRIPTIONS[unitCode]}</small>
              </span>
            </Link>
          ))}
        </div>
        {user?.unitCodes.length === 0 && (
          <div className="page-error" role="alert">
            Vaš uporabniški račun nima dodeljene nobene enote. Obrnite se na
            administratorja.
          </div>
        )}
      </main>
      <IdleLockOverlay />
    </div>
  );
}
